import { render, staticRenderFns } from "./MobileCallMe.vue?vue&type=template&id=7bacff22&scoped=true"
import script from "./MobileCallMe.vue?vue&type=script&lang=js"
export * from "./MobileCallMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bacff22",
  null
  
)

export default component.exports